import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useDepositMutation = () => {
  const branchId = useBranchId();

  const { t } = useTranslation("");
  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.update"));
    },
    mutationFn: ({
      account_id,
      partial_deposit,
    }: {
      account_id: string;
      partial_deposit: string;
    }) =>
      patch(
        `/internal/secure/pos/v1/personnel/add/new/record/partial/deposit/${branchId}/${account_id}`,
        { partial_deposit }
      ),
  });
  return mutation;
};

export default useDepositMutation;
